import { Component, Input, OnInit } from '@angular/core';
import { StudyInstanceModel } from '../../../shared/dataset/model/study-instance.model';

@Component({
    selector: 'jhi-study-instances-table-selector',
    templateUrl: './study-instances-table-selector.component.html',
    styleUrl: './study-instances-table-selector.component.scss'
})
export class StudyInstancesTableSelectorComponent implements OnInit {

    @Input() studyInstanceItems: StudyInstanceItem[];
    @Input() selectAll: boolean = false;
    searchQuery: any;

    ngOnInit(): void {
        if (this.selectAll) {
            this.doSelectAll();
        }
    }

    doSelectAll() {
        this.studyInstanceItems.forEach((instance) => {
            instance.isChecked = this.selectAll;
        });
    }
}

export class StudyInstanceItem extends StudyInstanceModel {
    isChecked: boolean;
}
